import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLocale } from '@/modules/locale/model/locale';
import { translationService } from '@/services/translation';
import useVuelidate from '@vuelidate/core';
import { minLength } from '@vuelidate/validators';

export function useTranslationList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            filterType: { type: 'number', default: 0 },
            criteria: { type: 'string', default: '' },
            locale: { type: 'string', default: '' },
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { localeSupportedOptions, getListSupported } = useLocale();

    const { list, total, fetchList } = useBaseListView({
        request: translationService.list,
        paramsBuilder: () => ({
            ...query,
            criteria: StringUtils.isEmpty(query.criteria) ? null : query.criteria
        }),
        hooks: {
            loadInitialData: async () => await getListSupported(),
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            canFetch: () => {
                if (StringUtils.isEmpty(query.locale)) {
                    list.value = [];
                    total.value = 0;
                    return false;
                }

                return true;
            }
        }
    });

    const validations = {
        criteria: { minLength: minLength(3) }
    };

    const v$ = useVuelidate(validations, query);

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: translationService.remove,
            onSuccess: () => fetchList()
        })
    };

    return { query, v$, list, total, fetchList, actions, localeSupportedOptions };
}
